/**
 * Message sent by a component (widget, page, ...) which is showed up and queued by the generic page
 * A message has got:
 * - a severity
 * - sender
 * - it is stamped for later display in the queued and past messages
 * - the code of the message (especially useful when coming from the Amasis backend)
 * - a text content
 */

export const MessageSeverity = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error',
}

export class Message {
  constructor(aLevel, aSender, aCode, aContent, aEnableDuplicates) {
    this.level = aLevel?.toLowerCase()
    this.sender = aSender
    this.date = new Date()
    this.code = aCode
    this.content = aContent
    this.enableDuplicates = aEnableDuplicates
  }
}
